import { RouteHandler } from 'wee-routes';
import { $extend } from 'core/types';
import Vue from 'vue';
import Vuex from 'vuex';
import findAResearcherOptions from './index.vue';

// Create component constructor
export const FindAResearcher = Vue.extend(findAResearcherOptions);

Vue.use(Vuex);

export const baseFilters = {
    name: '',
    specialty: '',
};

const createStore = () => new Vuex.Store({
    state: {
        filters: $extend({}, baseFilters, true),
    },
    mutations: {
        setFilter(state, { filter, value }) {
            state.filters[filter] = value;
        },
        resetFilters(state) {
            state.filters = $extend({}, baseFilters, true);
        },
        resetFilter(state, filter) {
            state.filters[filter] = baseFilters[filter] !== undefined ? baseFilters[filter] : '';
        },
    },
    actions: {
        setFilter({ commit }, payload) {
            commit('setFilter', payload);
        },
        resetFilters({ commit }) {
            commit('resetFilters');
        },
        resetFilter({ commit }, payload) {
            commit('resetFilter', payload);
        },
    },
    getters: {
        filters: state => state.filters,
    },
});
// Register and mount component
export default new RouteHandler({
    init() {
        new FindAResearcher({ store: createStore() }).$mount('.js-find-a-researcher');
    },
});
